<template>
  <div class="container">
    <common-title titleName="" bcColor="#F7F8FC" />
    <div class="content">
      <div class="title">请输入收货手机号查询订单信息</div>
      <div class="box">
        <van-field
          v-model="tel"
          maxlength="11"
          type="tel"
          placeholder="请输入收货手机号查询订单信息"
        />
        <van-field
          v-model="sms"
          maxlength="4"
          center
          clearable
          placeholder="请输入验证码"
        >
          <template #button>
            <div v-if="countDown === 0" class="textBtn" @click="getSms">获取验证码</div>
            <div v-else>{{ countDown }}s</div>
          </template>
        </van-field>
      </div>
      <div class="btn" @click="debounceSubmit">查询</div>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { reqPhonesliderCode } from '@/api/login';
import {
  reqBilibiliOrderValidateCode,
} from '@/api/bilibiliShipments/index';
import _ from 'lodash';
import { initCaptcha,triggerCaptcha } from '@/utils/tools';


// 验证码
const EXPIRE_TIME = 14 * 60 * 1000;
export default {
  data() {
    return {
      tel: '',
      sms: '',
      sessionTel: '',
      sessionSms: '',
      sessionTime: '',
      countDown: 0,
    };
  },
  components: {
    CommonTitle,
  },
  created() {
    this.init();
  },
  mounted(){
    initCaptcha('16dqi6jq',this.nvcCallback);
  },
  methods: {
    nvcCallback(data){
      this.getNewVerification(data)
    },
    init() {
      const phone = window.sessionStorage.getItem('bilibiliOrderPhone');
      const code = window.sessionStorage.getItem('bilibiliOrderCode');
      const time = window.sessionStorage.getItem('bilibiliOrderTime');
      if (!phone) return;
      this.sessionTel = phone;
      this.tel = phone;
      this.sessionTime = time;
      const timeNow = new Date().getTime();
      if (timeNow - this.sessionTime < EXPIRE_TIME) {
        this.sessionSms = code;
        this.sms = code;
      } else {
        sessionStorage.removeItem('bilibiliOrderTime');
      }
    },

    

    // 发送验证码
    async getNewVerification(nvcVal) {
      const data = {
        type: 'bilibili-order',
        phone: this.tel,
        templateCode: 'VerifyBO',
        company: 0,
        nvcVal,
         sceneId: '16dqi6jq'
      };
      const res = await reqPhonesliderCode(data);
      initCaptcha('16dqi6jq',this.nvcCallback);
      if (res.code === 0) {
        if (res.data.status === 0) {
          this.$toast('验证码已发送');
          this.countDown = 59;
          const timer = setInterval(() => {
            this.countDown -= 1;
            if (this.countDown === 0) {
              clearInterval(timer);
            }
          }, 1000);
        } else if (res.data.status === 1) {
          // 业务服务器请求回调控制是否需要二次验证
          if (res.data.bizCode === 800 || res.data.bizCode === 900) {
            // 无痕验证失败，直接拦截
            this.$toast('验证失败，请重新尝试');
          } else if (res.data.bizCode === 400) {
            triggerCaptcha()
          }
        }
      } else {
        this.$toast(res.msg);
      }
    },

    async getSms() {
      if (this.countDown > 0) return;
      const isPhone = this.$global.PHONEPATTEN.test(this.tel);
      if (!isPhone) {
        this.$toast('请输入正确格式的手机号');
        return;
      }
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      triggerCaptcha()
    },

    async submit() {
      const timeNow = new Date().getTime();
      // 如果手机号和验证码是上次验证成功的，且验证码未过期，直接进入列表页
      if (
        this.sessionTel === this.tel
        && this.sessionSms === this.sms
        && timeNow - this.sessionTime < EXPIRE_TIME
      ) {
        this.$router.push({
          path: '/bilibili-shipments/order-list',
          query: { verifyCode: this.sms, phone: this.tel },
        });
        return;
      }
      const isPhone = this.$global.PHONEPATTEN.test(this.tel);
      const isCode = /\d{4}/.test(this.sms);
      if (!isPhone || !isCode) {
        this.$toast('请输入正确手机号和验证码');
        return;
      }
      const res = await reqBilibiliOrderValidateCode({
        code: this.sms,
        phone: this.tel,
        type: 'bilibili-order',
      });
      if (res.code === 0) {
        const dateNow = new Date().getTime();
        window.sessionStorage.setItem('bilibiliOrderPhone', this.tel);
        window.sessionStorage.setItem('bilibiliOrderCode', this.sms);
        window.sessionStorage.setItem('bilibiliOrderTime', dateNow);
        this.$router.push({
          path: '/bilibili-shipments/order-list',
          query: { verifyCode: this.sms, phone: this.tel },
        });
      } else {
        this.$toast(res.msg);
      }
    },

    debounceSubmit() {
      const that = this;
      return _.debounce(that.submit, 1000)();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 100px;
  background: #F7F8FC;

  .content {
    margin-top: 72px;
    padding: 0 36px;

    .title {
      margin-bottom: 109px;
      color: #333;
      font-weight: 500;
      font-size: 33px;
    }

    .box {
      width: 100%;
      height: 234px;
      padding: 40px 36px;
      background: #FFF;
      border-radius: 14px;

      .textBtn {
        height: 36px;
        color: #FF7F41;
        font-size: 25px;
        line-height: 36px;
      }
    }

    .btn {
      width: 100%;
      height: 80px;
      margin-top: 72px;
      color: #fff;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #FF7F41;
      border-radius: 45px;
    }
  }

  .sliderCode {
    margin-top: 45px;
  }

  ::v-deep .sm-pop-inner {
    position: inherit;
  }
  ::v-deep .nc_wrapper {
  margin: 0 auto;
}
  ::v-deep .nc-container .nc_scale .btn_ok,
  ::v-deep .nc-container .nc_scale span {
    height: 68px !important;
  }
}
</style>
